import React from "react";
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Qualitypolicy() {

  // useEffect(()=>{
  //     document.title = 'Elixir | Our Qualitypolicy';
  //   }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Quality Policy</span></h1>
                <h4>“Simplicity is the Ultimate Sophistication”</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/qualitypolicy-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="innerPages-box3">      
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                  <hr />
                  <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                  <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                </div>
              </div> 
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>Printing Excellence, Powered by Innovation, Quality.</h3>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="aboutPages-box5">
                <h4>Quality Policy</h4>
                <p>At Elixir Advertising & AR Graphics, we are dedicated to delivering superior advertising, signage, and printing solutions built on innovation, precision, and reliability.</p>
                <p>We uphold the highest standards by implementing rigorous quality controls, embracing continuous improvement, and prioritizing customer satisfaction at every stage.</p>
                <p>Our commitment to excellence ensures that we consistently provide cutting-edge technology, creative solutions, and responsive support, enabling our clients to achieve impactful communication and flawless results.</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Qualitypolicy;
